import { z } from "zod"
import { DurationSchema, TimelineSchema } from "./timing"

export const BRollMediaInfoSchema = z.object({
  mediaType: z.enum(["image", "video"]).default("image"),
  originUrl: z.string(),
  previewUrl: z.string(),
  width: z.number().default(1080),
  height: z.number().default(1920),
  brollType: z.string().nullable().default(null),
  sourceId: z.string().nullable().default(null),
  duration: z.number().nullable().default(null),
  coverImage: z.string().nullable().default(null),
})

export const BRollContentSchema = z.object({
  id: z.string(),
  brollType: z.enum(["GenAi", "Stock"]).default("Stock"),
  mediaInfo: BRollMediaInfoSchema,
  prompt: z.string().nullable().default(null),
})

export const BRollSegmentSchema = z.object({
  id: z.string(),
  contentType: z.literal("BRoll"),
  duration: DurationSchema,
  timeline: TimelineSchema,
  trimStartMs: z.number().optional().describe("Where this piece starts in its media (ms); set when a segment is split"),
  content: BRollContentSchema,
  motion: z.enum(["zoom_in", "zoom_out", "pan_left", "pan_right", "none"]).default("zoom_in"),
  style: z.enum(["photo-realistic", "pop-art", "surreal"]).default("photo-realistic"),
})

export type BRollMediaInfo = z.infer<typeof BRollMediaInfoSchema>
export type BRollContent = z.infer<typeof BRollContentSchema>
export type BRollSegment = z.infer<typeof BRollSegmentSchema>

/** @deprecated Use BRollSegment instead */
export type BRollSegmentType = BRollSegment

export type BRollMotion = "zoom_in" | "zoom_out" | "pan_left" | "pan_right" | "none"
export type BRollStyle = "photo-realistic" | "pop-art" | "surreal"
